@if (isChangeRecordsLoaded) {
    <cb-lot-changes-action-bar
        *cbWaitFor="changeRecordMappedItems && lotMappedItem && teams"
        [lotMappedItem]="lotMappedItem"
        [changeRecordMappedItems]="changeRecordMappedItems"
        [teams]="teams"
        (changeRecordCreated)="changeRecordCreated($event)"
        (changesSubmittedForPricing)="changesUpdated($event)"
    >
    </cb-lot-changes-action-bar>
    <div class="cb-margin flex-row" style="gap: 16px">
        <cb-lot-changes-list
            class="flex-row"
            *cbWaitFor="changeRecordMappedItems && lotMappedItem"
            [changeRecordMappedItems]="changeRecordMappedItems"
            [lotId]="lotMappedItem.id"
            (changeRecordSelected)="changeRecordSelected($event)"
        ></cb-lot-changes-list>
        @if (selectedChangeRecord) {
            <cb-lot-change-view
                class="flex flex-row"
                [changeRecordMappedItem]="selectedChangeRecord"
                [lotMappedItem]="lotMappedItem"
                [teams]="teams"
            ></cb-lot-change-view>
        }
        @if (!selectedChangeRecord) {
            <cb-info-message
                [message]="'Select a Change to view the Change Details'"
            ></cb-info-message>
        }
    </div>
}
@if (!isChangeRecordsLoaded) {
    <cb-loading-spinner></cb-loading-spinner>
}
